/**
 * Internal approval-resume lines the model needs after Accept / Decline.
 * The UI never shows the raw instruction or the document ids it carries.
 * Only the full generated shapes match (mirrors shanks history/resume.go),
 * so a user who types "User declined…" keeps their own bubble.
 */ const TEMPLATES = [
    [
        /^User accepted: the ([^"]+) "([\s\S]+)" now exists in ([\s\S]+?) \([\s\S]*\)\. Continue with what they asked\.$/,
        (m)=>`✓ You created ${m[2].trim()} in ${m[3].trim()}`
    ],
    [
        /^User declined creating the ([^"]+) "([\s\S]+)"; nothing was created\. Ask what they want instead\.$/,
        (m)=>`You declined creating ${m[2].trim()}`
    ],
    [
        /^User declined: ([\s\S]+?)\. Nothing was done\. Ask what they want instead\.$/,
        (m)=>`You declined ${m[1].trim()}`
    ],
    // The publish receipt is the same user-facing text the card shows.
    [
        /^User accepted\. Done: ([\s\S]+)$/,
        (m)=>`✓ ${m[1].trim()}`
    ],
    [
        /^User accepted the proposed document changes; they have been applied to the document\.$/,
        ()=>'✓ You applied the document changes'
    ],
    [
        /^User rejected the proposed document changes\. Please ask what they would like changed\.$/,
        ()=>'You declined the document changes'
    ],
    [
        /^User approved and applied the proposed change: [\s\S]+\. The change was written under the user's account\.$/,
        ()=>'✓ You applied the change'
    ],
    [
        /^User rejected the proposed change: [\s\S]+\. Ask what they would like to do instead\.$/,
        ()=>'You declined the change'
    ],
    // SopWriteCard (sops tool, propose).
    [
        /^User accepted: saved the (personal|organization) SOP (\S+)\. Continue with what they asked\.$/,
        (m)=>`✓ You saved the ${m[1]} SOP ${m[2]}`
    ],
    [
        /^User declined saving the SOP (\S+)\. Nothing was saved\. Ask what they want instead\.$/,
        (m)=>`You declined the SOP ${m[1]}`
    ],
    [
        /^User feedback on the proposed SOP: [\s\S]+$/,
        ()=>'You left feedback on the proposed SOP'
    ],
    [
        /^User feedback on (?:proposed changes|the proposed change): [\s\S]+$/,
        ()=>'You left feedback on the proposal'
    ]
];
/** Slim note for a resume instruction. Empty when the text is a real user message. */ export function approvalResumeNote(text) {
    const t = text.trim();
    for (const [re, note] of TEMPLATES){
        const m = re.exec(t);
        if (m) return note(m);
    }
    return '';
}
export function isApprovalResume(text) {
    return approvalResumeNote(text) !== '';
}
